import React, { ReactNode } from 'react';

import { classNames } from '../../utils/style';
export interface ExampleProps {
  title?: string;
  children?: ReactNode;
}

export const Example = ({ title, children }: ExampleProps) => {
  return (
    <section className="Example v2">
      {title && (
        <p
          className={classNames(
            'inline-block rounded-6',
            'bg-blue-21 text-blue-101',
            'py-8 px-16'
          )}
        >
          {title}
        </p>
      )}
      <div className="pl-24 mt-24">{children}</div>
    </section>
  );
};

